import { Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";



@Pipe({
    name: 'datainterpreter',
    pure: false // Set pure to false to allow for stateful transformations
  })
  export class DataInterpreterPipe implements PipeTransform {
  
    constructor(private translateService: TranslateService) {}
  
    transform(value: string, ...args: any[]): any {
  
      let originalTranslation = value;
  
      // Loop through replacing the parameters
      for (let i=0; i<args.length; i++)
      {
          if (i % 2 == 0)
          {
              let searchString = "{{$" + args[i] + "}}";
              originalTranslation = originalTranslation.replaceAll(searchString, args[i+1]);
          }
      }
  
      return originalTranslation;
    }
  }